import React, { Component } from 'react'
import { Button, Col, Form, Input, message, Modal, Row, Select, Steps, Table } from 'antd'
import Members from '../../../api/Members'
import { getLabel, strVal } from '../../../modules/Utils'
import PersonalDetails from '../Form/PersonalDetails'
import ContactDetails from '../Form/ContactDetails'
import omitEmpty from 'omit-empty'

const FormItem = Form.Item
const Option = Select.Option
const Step = Steps.Step
const Search = Input.Search

class AddPhoneBook extends Component {
  constructor(props) {
    super(props)
    this.uuid = 0
    this.state = {
      type: '',
      fetching: false,
      fetchingContact: false,
      submitting: false,
      contact: {
        phone: [],
        email: [],
        mobile: [],
        address: [],
      },
      member: {},
      selectedRowKeys: [],
      current: 0,
      data: [],
      list: [],
      pagination: {
        showSizeChanger: true,
        size: 'small',
        pageSize: 5,
        showTotal: total => {
          return `${total} Record`
        },
      },
    }
    this.api = new Members()
  }

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    this.setState({ fetching: true })
    let response = await this.api.phonebook()
    let list = await response.json()
    this.setState({ data: list, list, fetching: false })
  }

  fetchContact = async () => {
    try {
      this.setState({ fetchingContact: true })
      const response = await this.api.contacts.get(this.state.member._key)
      const contact = await response.json()
      this.setState({
        contact: Object.assign({}, this.state.contact, contact),
        fetchingContact: false,
      })
    } catch (err) {
      this.setState({ fetchingContact: false })
      console.error(err)
    }
  }

  async next() {
    if (this.state.current === 0 && this.state.type === '') message.error('Please select a type ')
    else if (this.state.current === 1) {
      this.checkForm()
    } else {
      const current = this.state.current + 1
      this.setState({ current })
    }
  }

  submit = async () => {
    let valid = false
    try {
      valid = await this.checkContact()
      if (valid) {
        let contactsObj = this.state.contact
        let contacts = []
        for (let i in contactsObj) contacts.push(...contactsObj[i])
        contacts = contacts.filter(c => !(c.new === true && c.remove === true))
        let newMember = omitEmpty(
          Object.assign({}, { kind: this.state.type }, { contacts }, omitEmpty(this.state.member)),
        )
        try {
          this.setState({
            submitting: true,
          })
          await this.api.create(newMember)
          this.setState({
            submitting: false,
            current: 0,
          })
          this.props.handleCancel(true)
        } catch (err) {
          message.error(err.errorMessage)
          this.setState({
            submitting: false,
          })
        }
      }
    } catch (error) {
      console.error(error)
      message.error(error.errorMessage)
      this.setState({ submitting: false })
    }
  }

  prev() {
    const current = this.state.current - 1
    this.setState({ current })
  }

  checkForm = () => {
    this.personalCmp.validateFields(async (err, values) => {
      if (!err) {
        await this.fetchContact()
        let personalDetails = values
        const current = this.state.current + 1
        this.setState({
          current,
          member: Object.assign({}, this.state.member, personalDetails),
        })
      }
    })
  }
  checkContact = () => {
    return new Promise((res, rej) => {
      this.contactCmp.validateFields((err, values) => {
        if (!err) {
          res(true)
        }
      })
    })
  }
  columns = [
    {
      title: 'Full Name',
      dataIndex: 'fn',
      onFilter: (value, record) => strVal(record, 'fn').indexOf(value) === 0,
      sorter: (a, b) => strVal(a, 'fn').toUpperCase() < strVal(b, 'fn').toUpperCase(),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      render: (text, record, index) => strVal(record, 'email.label'),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      render: (text, record, index) => strVal(record, 'phone.label'),
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      render: (text, record, index) => strVal(record, 'mobile.label'),
    },
  ]

  handleFilter = type => {
    this.search(this.state.searchWord, type)
    this.setState({
      type,
      selectedRowKeys: [],
      member: {},
    })
  }
  handleOnSearch = e => {
    const value = strVal(e, 'target.value')
    this.search(value, this.state.type)
    this.setState({
      searchWord: value,
      selectedRowKeys: [],
      member: {},
    })
  }
  search = (value, type) => {
    let filtered = this.state.data.map(a => a)
    if (value)
      filtered = filtered.filter(row => {
        return (
          strVal(row, 'fn')
            .toUpperCase()
            .includes(value.toUpperCase()) ||
          strVal(row, 'email.label')
            .toUpperCase()
            .includes(value.toUpperCase())
        )
      })
    if (type) filtered = filtered.filter(i => i.kind === type)
    this.setState({ list: filtered })
  }
  onSelect = (record, selected) => {
    if (!selected) this.setState({ selectedRowKeys: [], member: {} })
    else this.setState({ selectedRowKeys: [record._key], member: record })
  }
  onSelectAll = () => {
    this.setState({ selectedRowKeys: [], member: {} })
  }
  handleAdd = type => {
    let list = this.state.contact[type].slice()
    list.push({
      category: type,
      label: '',
      default: list.length < 1,
      _key: (this.uuid++).toString(),
      new: true,
    })
    this.setState({
      contact: Object.assign({}, this.state.contact, { [type]: list }),
    })
  }
  handleRemove = (type, _key) => {
    let list = this.state.contact[type].slice()
    let removed = list.find(c => c._key === _key)
    removed['remove'] = true
    this.setState({
      contact: Object.assign({}, this.state.contact, { [type]: list }),
    })
  }
  handleDefault = (type, _key) => {
    let list = this.state.contact[type].slice()
    let currentDefault = list.find(e => e.default === true)
    if (currentDefault) currentDefault['default'] = false
    let item = list.find(e => e._key === _key)
    item['default'] = true
    this.setState({
      contact: Object.assign({}, this.state.contact, { [type]: list }),
    })
  }
  handleChange = (type, _key, name, event) => {
    let list = this.state.contact[type].slice()
    let item = list.find(e => e._key === _key)
    item[name] = event.target ? event.target.value : event
    if (item.category === 'address' && name !== 'label') item.label = getLabel(item)
    this.setState({
      contact: Object.assign({}, this.state.contact, { [type]: list }),
    })
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onSelectAll: this.onSelectAll,
      onSelect: this.onSelect,
    }
    const steps = [
      {
        title: 'Search for Existing',
        content: (
          <div style={{ marginTop: 20 }}>
            <Form layout="horizontal">
              <Row>
                <Col span={24}>
                  <FormItem
                    {...formItemLayout}
                    label="Name"
                    hasFeedback
                    validateStatus={this.state.fetching && 'validating'}>
                    <Search
                      placeholder="You can search Full name or Email  ... "
                      onSearch={value => this.handleOnSearch({ target: { value } })}
                      onChange={this.handleOnSearch}
                      value={this.state.searchWord}
                    />
                  </FormItem>
                  <FormItem {...formItemLayout} label="Type">
                    <Select showSearch value={this.state.type} onChange={this.handleFilter}>
                      <Option checked={true} value={'individual'}>
                        Individual
                      </Option>
                      <Option value={'organisation'}>Organisation</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            <Row style={{ textAlign: 'left' }}>
              <p style={{ fontWeight: 'bold', fontSize: 12 }}>RESULTS</p>
              <span style={{ fontStyle: 'italic' }}>
                Select an existing contact to update details or continue to Add New Contact.
              </span>
              <Table
                loading={this.state.fetching}
                rowKey={'_key'}
                pagination={this.state.pagination}
                showHeader={true}
                rowSelection={rowSelection}
                columns={this.columns}
                dataSource={this.state.list}
              />
            </Row>
          </div>
        ),
      },
      {
        title: 'General Details',
        content: (
          <PersonalDetails
            ref={child => {
              this.personalCmp = child
            }}
            checkForm={this.state.checkForm}
            type={this.state.type}
            member={this.state.member}
            list={this.state.data.filter(m => m.kind !== 'individual')}
          />
        ),
      },
      {
        title: 'Contact Details',
        content: (
          <ContactDetails
            handleChange={this.handleChange}
            handleDefault={this.handleDefault}
            handleRemove={this.handleRemove}
            handleAdd={this.handleAdd}
            contact={this.state.contact}
            fetching={this.state.fetchingContact}
            ref={child => {
              this.contactCmp = child
            }}
            member={this.state.member}
            formItemLayout={formItemLayout}
          />
        ),
      },
    ]

    const { visible, handleOk, handleCancel } = this.props

    return (
      <Modal
        title="Add to PhoneBook"
        destroyOnClose={true}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        maskClosable={false}
        footer={null}>
        <Steps current={this.state.current}>
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content">{steps[this.state.current].content}</div>
        <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
          {this.state.current > 0 && (
            <Button style={{ marginRight: 8 }} onClick={() => this.prev()}>
              Previous
            </Button>
          )}
          {this.state.current < steps.length - 1 && (
            <Button
              style={{ width: '100px' }}
              type="primary"
              loading={this.state.fetchingContact}
              onClick={() => this.next()}>
              Next
            </Button>
          )}
          {this.state.current === steps.length - 1 && (
            <Button type="primary" loading={this.state.submitting} onClick={this.submit}>
              Submit
            </Button>
          )}
        </div>
      </Modal>
    )
  }
}

export default AddPhoneBook
